import { t, tNow } from '@/i18n/languageStore';

/** Formatting shared by Home, the neighbour profile, promotions and events (mobile/src/screens/home/homeFormat.ts). */
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "just now", "5m ago", "3h ago", "2d ago", then a short date. */
export function timeAgo(iso: string, now: Date = new Date()): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const minutes = Math.max(0, Math.round((now.getTime() - then) / 60000));
  if (minutes < 1) return t('just now');
  if (minutes < 60) return t('{n}m ago', { n: minutes });
  const hours = Math.round(minutes / 60);
  if (hours < 24) return t('{n}h ago', { n: hours });
  const days = Math.round(hours / 24);
  if (days < 7) return t('{n}d ago', { n: days });
  const d = new Date(iso);
  return `${MONTHS[d.getMonth()]} ${d.getDate()}`;
}

/** "350 m" under a kilometre, otherwise "2.0 km". */
export function formatFeedDistance(km: number | null | undefined): string {
  if (km == null) return '';
  return km < 1 ? `${Math.round(km * 1000)} m` : `${km.toFixed(1)} km`;
}

/** "Ends Oct 31", or "Ongoing" when the promotion has no end date. */
export function formatExpires(iso?: string | null): string {
  if (!iso) return tNow('Ongoing');
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return tNow('Ongoing');
  return tNow('Ends {MONTHS} {getUTCDate}', {
    MONTHS: MONTHS[d.getUTCMonth()],
    getUTCDate: d.getUTCDate(),
  });
}

/** "Oct 18, 2026 · 11:00 AM", in the viewer's time zone. */
export function formatEventDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const suffix = hours >= 12 ? 'PM' : 'AM';
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  return `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()} · ${hour12}:${minutes} ${suffix}`;
}
